import { render, staticRenderFns } from "./CreditsOutstandingTable.vue?vue&type=template&id=ee0d8ae2"
import script from "./CreditsOutstandingTable.vue?vue&type=script&lang=js"
export * from "./CreditsOutstandingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports